import { render, staticRenderFns } from "./Climatology-old.vue?vue&type=template&id=59a643fa"
import script from "./Climatology-old.vue?vue&type=script&lang=js"
export * from "./Climatology-old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports